import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginResponse } from 'admin/baseLogin/LoginResponse';
import { BaseAccountService } from 'admin/baseLogin/BaseAccountService';
import { ContactUsResponse } from 'admin/utile/contactUs/contactUsForm/contact-us-form.component';


@Injectable()
export class AccountService extends BaseAccountService
{
    constructor(
        protected http: HttpClient)
    {
        super(http);
    }

	sendMessage(message: string): Observable<ContactUsResponse> {
		return this.http.post<ContactUsResponse>("/AccountCalls/SendMessage", { message });
	}

    joinCompany(code: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/JoinCompany", { InviteCode: code } );
    }

    createCompany(name: string, code: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/CreateCompany", { Name: name, InviteCode: code });
    }

    isAuthenticated(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/IsAuthenticated", null);
    }

    hasCompanySet(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/HasCompanySet", null);
    }

    register(email: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/Register", { email: email, password: password });
    }

    login(email: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/Login", { email: email, password: password });
    }

}
